import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { ListItem, ListItemIcon, ListItemText, Link } from '@material-ui/core'

export default function ListItemLink({
  selected,
  setSelected,
  component,
  linkProps,
  primary,
  icon,
}) {
  return (
    <ListItem
      button
      selected={selected}
      onClick={setSelected}
      component={component}
      {...linkProps}
    >
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={primary} />
    </ListItem>
  )
}

ListItemLink.propTypes = {
  /**
   * Apply the 'selected' styling
   */
  selected: PropTypes.bool,

  /**
   * Handler to call when the ListItem is clicked
   */
  setSelected: PropTypes.func,

  /**
   * Link component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.oneOf(['a', GatsbyLink, Link]),

  /**
   * Props for the anchor element
   */
  linkProps: PropTypes.object,

  /**
   * Props for the ListItemText component
   */
  listItemTextProps: PropTypes.object,

  /**
   * The icon to render
   */
  icon: PropTypes.element,
}

ListItemLink.defaultProps = {
  selected: false,
  setSelected() {},
  component: 'a',
  linkProps: {},
  listItemTextProps: {},
  icon: null,
}
